'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Select = require('./Select');

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getOptionFromValue(_ref) {
  var options = _ref.options,
      value = _ref.value,
      valueKey = _ref.valueKey;

  return options.find(function (option) {
    return getValueFromOption(option, valueKey) === value;
  });
}

function getValueFromOption(option, valueKey) {
  return valueKey === null ? option : option[valueKey];
}

var SingleSelect = function (_PureComponent) {
  _inherits(SingleSelect, _PureComponent);

  function SingleSelect(props) {
    _classCallCheck(this, SingleSelect);

    var _this = _possibleConstructorReturn(this, (SingleSelect.__proto__ || Object.getPrototypeOf(SingleSelect)).call(this, props));

    _this.handleSelection = function (selectedOption) {
      return _this.setState({ selectedOption: selectedOption });
    };

    _this.handleDone = function (selectedOption) {
      // SelectedOption can be undefined if they user clicks "done" -- there's no new selection
      var valueKey = _this.props.valueKey;

      if (selectedOption) {
        _this.setState({ selectedOption: selectedOption });
        _this.props.onChange(getValueFromOption(selectedOption, valueKey));
      }
    };

    _this.state = {
      selectedOption: getOptionFromValue(props)
    };
    return _this;
  }

  _createClass(SingleSelect, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var value = this.props.value;
      var selectedOption = this.state.selectedOption;

      var newSelectedOption = getOptionFromValue(this.props);
      if (prevProps.value !== value && newSelectedOption !== selectedOption) {
        this.setState({
          selectedOption: newSelectedOption
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var selectedOption = this.state.selectedOption;

      var selectedOptions = selectedOption ? [selectedOption] : [];
      return _react2.default.createElement(
        'div',
        { className: 'SingleSelect' },
        _react2.default.createElement(_Select2.default, _extends({
          onDone: this.handleDone,
          handleSelection: this.handleSelection,
          selectedOptions: selectedOptions
        }, this.props))
      );
    }
  }]);

  return SingleSelect;
}(_react.PureComponent);

// Note that Select takes a ton of additional props


SingleSelect.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  onInputChange: _propTypes2.default.func,
  value: _propTypes2.default.any,
  options: _propTypes2.default.array.isRequired,
  valueKey: _propTypes2.default.string,
  displayKey: _propTypes2.default.string,
  name: _propTypes2.default.string
};

SingleSelect.defaultProps = {
  value: '',
  options: [],
  valueKey: 'value',
  displayKey: 'text',
  onInputChange: function onInputChange() {
    return undefined;
  }
};

exports.default = SingleSelect;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/FormInputs/Select/SingleSelect.js
// module id = 229
// module chunks = 0